import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';

export const getCarrierTabNavigationProps = originExchangeOfficesData => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
    mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id,
    requestParams: {
      carrier: rowInfo.row['cardit.carrier'],
      originExchangeOffices: originExchangeOfficesData.originExchangeOffices,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_107B.id,
    ],
  } : {}
);

export default (data, originExchangeOfficesData) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new TextColumn('Carrier', 'cardit.carrier').withTotalHeader('Total', 'bg-total-darkGrey'),
        new NavigationWithFooterColumn(new NonZeroNumberColumn('Total', 'cardit.total').withTotalHeader(sumTotal, 'bg-total-darkGrey'), getCarrierTabNavigationProps(originExchangeOfficesData)),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
        mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id,
        requestParams: {
          isTotal: true,
          carrier: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
    {
      Header: 'RESDIT',
      columns: [
        new NonZeroNumberColumn('74', 'resdit.resdit74').withTotalHeader(sumTotal, 'bg-total-darkGrey'),
        new NonZeroNumberColumn('21', 'resdit.resdit21').withTotalHeader(sumTotal, 'bg-total-darkGrey'),
      ],
    },
  ];
};
